export default {
notification: {
  read: "อ่านแล้ว",
  unread: "ยังไม่ได้อ่าน",
  hide: "ซ่อน",
  showAll: "แสดงทั้งหมด",
  loading: "กำลังโหลด...",
  noMore: "ไม่มีข้อมูลเพิ่มเติม",
  platform: "แพลตฟอร์ม",
  personal: "ส่วนตัว"
}
};
